/**
 * @desc        Store
 * @version     1.1 (updated thunk) - 16 Sept 24 **/

import { applyMiddleware, compose } from 'redux'
import { persistStore } from 'redux-persist'
import thunk from 'redux-thunk'
import { awsRefreshToken } from './actions/aws/aws-action.js'
import reducers from './reducers/index.js'
import StoreManager from './store-manager'

const composeEnhancers =
    process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
              shouldHotReload: false,
          })
        : compose
StoreManager.registerReducers(reducers)
const store = StoreManager.createStore(composeEnhancers(applyMiddleware(thunk)))
const persistor = persistStore(store, null, () => {
    doRefresh()
})
// Dev only. Reading the real store beats inferring its contents from the DOM when something is
// rendering empty and the question is whether the data ever arrived.
if (process.env.NODE_ENV !== 'production') window.store = store

export { persistor, store }

const SESSION_TIMER = 1000 * 60 * 15 // 15 minutes
let sessionTimeout = null
const setSessionTimeout = () => {
    clearTimeout(sessionTimeout)
    sessionTimeout = setTimeout(doRefresh, SESSION_TIMER)
}
const doRefresh = () => {
    store.dispatch(awsRefreshToken({}))
    setSessionTimeout()
}

//TODO: Fix this later
// try {
//     const channel = new BroadcastChannel('tab')
//     let isOriginal = true
//     channel.postMessage('another-tab')
//     channel.addEventListener('message', (msg) => {
//       if (msg.data === 'another-tab' && isOriginal) {
//         channel.postMessage('already-open')
//       }
//       if (msg.data === 'already-open') {
//         isOriginal = false
//         window.alert('Please close this tab to avoid conflicts with the existing open Farmdeck tab.')
//       }
//     })
//   } catch (err) {
//     console.error(err)
//   }
